import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import GroupCreationForm from './GroupCreationForm';
import usePostCreateGroup from '../../../hooks/useApi/usePostCreateGroup';
import { GroupCreationDialogueHandler, DialogueHandlerProps } from '../Dialogue/types';
import GroupCreationDialogueContext, { GroupCreationCtx } from '../Dialogue/CreateGroup/CreateGroupContext';
import GroupGreationDialogue from '../Dialogue/CreateGroup/CreateGroupDialogue';
import { useTranslation } from 'react-i18next';

const { Box, Title } = vp;

type FC = FunctionComponent;

const GroupCreationContainer: FC = () => {
  const history = useHistory();
  const [groupCreationResponse, postCreateGroup] = usePostCreateGroup({});
  const [shouldCreateGroup, setShouldCreateGroup] = useState(false);
  const [showGroupCreationErrorAlert, setShowGroupCreationErrorAlert] = useState(false);
  const [groupCreationError, setGroupCreationError] = useState('');
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Create' });

  const GroupCreation: GroupCreationCtx = {
    showGroupCreationErrorAlert,
    groupCreationError,
  };

  const handlers = {
    handleGroupCreationDialogue: (handlerProps: DialogueHandlerProps<GroupCreationDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;
      const dialogueHandlers: GroupCreationDialogueHandler = {
        error: {
          confirm: {
            default: () => {
              setShowGroupCreationErrorAlert(false);
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;
      handler();
    },
    onGroupCreation: (_values: vp.CreateGroupRequest) => {
      setShouldCreateGroup(true);
      postCreateGroup({
        GroupName: _values.GroupName,
        Description: _values.Description,
        Service: _values.Service,
        Currency: _values.Currency,
      });
    },
  };

  useEffect(() => {
    if (shouldCreateGroup) {
      const { Success, ErrorMessage } = groupCreationResponse;

      if (Success === true) {
        history.goBack();
      } else if (Success === false) {
        setShowGroupCreationErrorAlert(true);
        setGroupCreationError(ErrorMessage);
      }
      setShouldCreateGroup(false);
    }
  }, [groupCreationResponse]);

  return (
    <GroupCreationDialogueContext.Provider value={GroupCreation}>
      <Box mb="md" flx="col" gap="lg">
        <Box mb="md" jc="sb">
          <Title title={t('pageTitle')} />
        </Box>
        <GroupCreationForm handlers={handlers} />
      </Box>
      <GroupGreationDialogue handleDialogue={handlers.handleGroupCreationDialogue} />
    </GroupCreationDialogueContext.Provider>
  );
};

export default GroupCreationContainer;
